<template>
  <div>
    <v-row class="pt-3">
    <v-col cols="6" sm="12" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อโปรเจค</span>
      <v-select
        v-model="keywordCompanyName"
        :items="itemCompanyName"
        item-text="projectName"
        item-value="projectName"
        multiple
        outlined
        placeholder="ค้นหา ชื่อโปรเจค"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
      <template v-slot:prepend-item v-if="itemCompanyName.length > 1">
          <v-list-item
            ripple
            @click="toggleCompany"
          >
            <v-list-item-action>
              <v-icon :color="keywordCompanyName.length > 0 ? 'indigo darken-4' : ''">
                {{ iconCompany }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                เลือกทั้งหมด
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-0"></v-divider>
        </template>
        <template #selection="{ item, index }">
          <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
            <span v-if="keywordCompanyName.length !== itemCompanyName.length" class="filter-chip_department" style="color: #3776E9">{{item.projectName}}</span>
            <span v-else-if="keywordCompanyName.length === itemCompanyName.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
          </v-chip>
          <v-chip  v-if="index === 1 && keywordCompanyName.length !== itemCompanyName.length" color="#EFF4FD !important" label small>
            <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordCompanyName.length - 1 }} เพิ่มเติม)</span>
          </v-chip>
        </template>
      </v-select>
    </v-col>
    <v-col cols="6" sm="12" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อผู้ร้องขอ</span>
      <v-select
        v-model="keywordSmall"
        :items="itemSmall"
        item-text="userName"
        item-value="userName"
        multiple
        outlined
        placeholder="ค้นหา ชื่อผู้ร้องขอ"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
    <template v-slot:prepend-item v-if="itemSmall.length > 1">
      <v-list-item
        ripple
        @click="toggleOrgchart"
      >
        <v-list-item-action>
          <v-icon :color="keywordSmall.length > 0 ? 'indigo darken-4' : ''">
            {{ iconOrgchart }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            เลือกทั้งหมด
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-0"></v-divider>
    </template>
    <template #selection="{ item, index }">
      <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
        <span v-if="keywordSmall.length !== itemSmall.length" class="filter-chip_department" style="color: #3776E9">{{item.userName}}</span>
        <span v-else-if="keywordSmall.length === itemSmall.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
      </v-chip>
      <v-chip  v-if="index === 1 && keywordSmall.length !== itemSmall.length" color="#EFF4FD !important" label small>
        <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordSmall.length - 1 }} เพิ่มเติม)</span>
      </v-chip>
    </template>
      </v-select>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getSelectApproveRequestToken
} from '@/API/API'
// import axios from 'axios'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  data () {
    return {
      // tapData: ['', 'waiting', 'pending', 'approve', 'reject', 'cancel'],
      tapData: ['', 'pending', 'approve', 'reject', 'cancel'],
      tapSelect: 0,
      keywordBusinessName: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordGroupCompanyName: [],
      itemUserName: [],
      itemReqNo: [],
      itemPosition: [],
      itemRequestType: [],
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        companyName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รออนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' },
          { value: 'cancel', text: 'ยกเลิก' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      menu1: false,
      datesUpdateAt: [],
      datesCreateAt: [],
      menu2: false,
      createAt: '',
      updateAt: '',
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      totalCancel: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      textBtnOk: this.mode === 'approve' ? 'Approve' : 'Acknowledge',
      textBtnNO: this.mode === 'approve' ? 'Reject' : 'Unacknowledge',
      approveRole: localStorage.approveRole,
      businessType: '',
      keywordSmall: [],
      keywordCompanyName: [],
      keywordGroupName: [],
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemCompanyName: ['INET', 'OGS'],
      itemGroupCompanyName: ['INET', 'OGS']
    }
  },
  watch: {
    // approveRole () { return localStorage.approveRole }
    datesUpdateAt: function (val) {
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
        // this.searchFilterData()
      }
    },
    datesCreateAt: function (val) {
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        // this.searchFilterData()
      }
    }
  },
  computed: {
    // approveRole () { return localStorage.approveRole }
    dateRangeTextUpdate () {
      const chkDate = ''
      if (this.datesUpdateAt.length !== 0) {
        return this.datesUpdateAt.join(' ~ ')
      } else {
        return chkDate
      }
    },
    dateRangeTextCreate () {
      const chkDate = ''
      // return this.datesCreateAt.join(' ~ ')
      if (this.datesCreateAt.length !== 0) {
        return this.datesCreateAt.join(' ~ ')
      } else {
        return chkDate
      }
    },
    selectAllCompany () {
      return this.keywordCompanyName.length === this.itemCompanyName.length
    },
    selectSomeCompany () {
      return this.keywordCompanyName.length > 0 && !this.selectAllCompany
    },
    iconCompany () {
      if (this.selectAllCompany) return 'mdi-close-box'
      if (this.selectSomeCompany) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllOrgchart () {
      return this.keywordSmall.length === this.itemSmall.length
    },
    selectSomeOrgchart () {
      return this.keywordSmall.length > 0 && !this.selectAllOrgchart
    },
    iconOrgchart () {
      if (this.selectAllOrgchart) return 'mdi-close-box'
      if (this.selectSomeOrgchart) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  async created () {
    await this.getSelectData()
    await this.searchFilterData()
  },
  beforeDestroy () {
    EventBus.$off('manageExternalToken')
    EventBus.$off('updateTotalMarket')
    EventBus.$off('setApproveRole')
    EventBus.$off('updateDataDelete')
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    // EventBus.$on('selectPosition', this.getSelectValue)
    EventBus.$on('updateTotalMarket', this.updateTotal)
    EventBus.$on('setApproveRole', this.setApproveRole)
    EventBus.$on('updateDataDelete', this.getSelectData)
  },
  methods: {
    toggleCompany () {
      this.$nextTick(() => {
        if (this.selectAllCompany) {
          this.chkCompanyName = false
          this.keywordCompanyName = []
        } else {
          this.chkCompanyName = true
          this.keywordCompanyName = this.itemCompanyName.slice()
          for (let index = 0; index < this.keywordCompanyName.length; index++) {
            this.memoryCompanyName = []
          }
          this.searchFilterData()
        }
      })
    },
    toggleOrgchart () {
      this.$nextTick(() => {
        if (this.selectAllOrgchart) {
          this.chkOrgchart = false
          this.keywordSmall = []
        } else {
          this.chkOrgchart = true
          this.keywordSmall = this.itemSmall.slice()
          for (let index = 0; index < this.keywordSmall.length; index++) {
            this.memoryOrgchart = []
          }
        }
        this.searchFilterData()
      })
    },
    // async setApproveRole () {
    //   this.approveRole = localStorage.approveRole
    //   this.page = 1
    //   this.resetFilterData()
    //   await this.getSelectData()
    //   await this.searchFilterData()
    // },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
      this.totalCancel = value.totalCancle
    },
    async getSelectData () {
      const obj = {
        tap: 'tokenTap',
        userName: this.keywordSmall,
        projectName: this.keywordCompanyName,
        role: this.approveRole
      }
      try {
        // const res = await getSelectApproveRequestCompany({ approveType: this.mode, role: this.approveRole }, this.$store.state.token)
        const res = await getSelectApproveRequestToken(obj, this.$store.state.token)
        if (res.success) {
          if (res.result) {
            this.itemCompanyName = res.result.resultDataToken
            this.itemSmall = res.result.resultDataToken
            this.itemUserName = res.result.companyNameList
            this.itemReqNo = res.result.reqBusinessNoList
            this.itemBusiness = res.result.businessTypeList
          }
        }
      } catch (error) {
      } finally {
      }
    },
    resetUpdateDate () {
      this.updateAt = ''
      this.datesUpdateAt = []
      this.searchFilterData(1, 15)
    },
    resetCreateDate () {
      this.createAt = ''
      this.datesCreateAt = []
      this.searchFilterData(1, 15)
    },
    resetFilterData () {
      this.businessType = ''
      this.keywordBusinessName = ''
      this.keywordRequestNo = ''
      this.keywordPosition = []
      this.keywordType = []
      this.keywordCompanyName = []
      this.keywordGroupCompanyName = []
      this.createAt = ''
      this.updateAt = ''
      this.datesUpdateAt = []
      this.datesCreateAt = []
      this.filterData = {
        businessType: '',
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode
      }
      this.searchFilterData(1, 15)
    },
    searchFilterData () {
      this.filterData = {
        tap: 'tokenTap',
        userName: this.selectAllOrgchart === true ? this.memoryOrgchart : this.keywordSmall,
        projectName: this.selectAllCompany === true ? this.memoryCompanyName : this.keywordCompanyName,
        role: this.approveRole
      }
      EventBus.$emit('manageExternalToken', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-role-company {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 9px 24px; */

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-role-company {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
